import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { OrderType } from "../../types/types";
import {
  updateOrderStatus,
  updateOrder,
  createInvoice,
  updateInvoiceStatus,
  getSinglePrimaryOrder,
} from "../../services/manageOrderService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getEditOrderConfig,
  getViewOrderConfig,
  setAndGetViewOrderEditTableHeader,
} from "../viewOrder/ViewOrderConfig";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BorderHeading from "../../components/heading/BorderHeading";
import FormHeader from "../../components/dms_common/FormHeader";
import CustomAccordian from "../../components/dms_common/CustomAccordian";
import {
  checkForEmptyTable,
  checkAllRowsHaveValidStock,
  createAndDownloadInvoicePdf,
  getBatchCodes,
  getOrderTotalRowData,
  initialDiscountState,
  modifyCartToValidate,
  prepareEditOrderReqBody,
  getGenericModalProps,
  initialGenericModalProps,
  GenericModal,
  buttonLoading,
  customStyle,
  showOverlayIn,
  createSkuWiseStockMap,
} from "../viewOrder/ViewOrderUtils"
import CustomTablewithTotalInfo from "../../components/dms_common/CustomTablewithTotalInfo";
import {
  getValidateRequestBody,
  updateMultiQtyInCart,
  updateQuantityInCart,
} from "../createSecondaryOrder/CreateSecondaryOrderService";
import NewDiscountModal from "../claimsNew/modals/NewDiscountModal";
import { setDiscountModalState } from "../../stateManagement/actions/claims";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import { ChannelkartNetworkPost } from "../../services/networkService";
import CircularProgress from "@mui/material/CircularProgress";
import Search from "../../components/dms_common/Search";
import { getDataFromLocalDb } from "../../services/dbService";
import { createCatalogue, performUomConversionPrimary } from "../../services/catalogueService";
import { getConfigData } from "../../services/configurationService";
import { filterData, searchWithStatusFilter } from "../../components/dms_common/DmsCommonServices";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { Cart, Catalogue } from "../createSecondaryOrder/models";
import "./ViewPrimaryOrderOms.css";
import ScreenOverlay from "../../components/dms_common/ScreenOverlay";
import { createScrollHandler, handleScroll, truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { PendingButtons } from "../viewOrder/PendingButtons";
import OrderCancelModal from "../viewOrder/OrderCancelModal";
import { DiscountDetails, viewManageOrderRowsData } from "../viewOrder/ViewOrderType";
import { getMetaData1ViewPrimaryOMS, metaData2ViewPrimaryOMS } from "../viewPrimaryOrder/ViewPrimaryOrderConfig";
import dayjs from "dayjs";
import { downloadGrnReport } from "../../services/manageReportService";
import { setRealTimeStockDataInDb } from "../stocks/RealTimeStock/RealTimeStockUtils";

const ViewPrimaryOrderOms = () => {
  const { orderId } = useParams();
  const [rows, setRows] = useState<viewManageOrderRowsData[]>([]);
  const [loader, setLoader] = useState(true);
  const [totalFooterValue, setTotalFooterValue] = useState<any[]>([]);
  const [orderData, setOrderData] = useState<any>({});
  const [invoiceExpired, setInvoiceExpired] = useState<boolean>(false);
  const [orderTrackingConfig, setOrderTrackingConfig] = useState<any[]>([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [discount, setDiscount] = useState<DiscountDetails>(initialDiscountState);
  const [selectedSkuCode, setSelectedSkuCode] = useState<any>({});
  const [cart, setCart] = useState<Cart>({});
  console.warn("DEBUGPRINT[384]: ViewPrimaryOrderOms.tsx:86: cart=", cart)
  const [catalogue, setCatalogue] = useState<Catalogue[]>([]);
  const [orderStatusChangeLoading, setOrderStatusChangeLoading] = useState<string>("");
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [TableHeaders, SetViewOrderEditTableHeader] = useState<Record<string, string>>({});
  const [saveChangesLoading, setSaveChangesLoading] = useState<boolean>(false);
  const [editLoading, setEditLoading] = useState<boolean>(false);
  const [orderCancelModalOpen, setOrderCancelModalOpen] = useState<boolean>(false);
  const [showPushToGrnButton, setPushToGrnButton] = useState<boolean>(false);
  const [showCancelOrderButton, setCancelOrderButton] = useState<boolean>(false);
  const [selectedRejectionReason, setSelectedRejectionReason] = useState<string>(``);
  const [rejectionReasons, setRejectionReasons] = useState<string[]>([]);

  const [isProcessing, setIsProcessing] = useState(false);
  const [filteredRows, setFilteredRows] = useState<viewManageOrderRowsData[]>([]);
  const hideAddMoreInEditOrder = useRef<boolean>(false);
  const disableStockCheck = useRef<boolean>(false);
  const kgbplDeliveryMetadata = useRef<boolean>(false);
  const disableSchemeCheck = useRef<boolean>(false);
  const hideItemLevelTaxInfo = useRef<boolean>(false);
  const showGoToInvoiceRedirectionButton = useRef<boolean>(false);
  const disableEditInvoiceFlow = useRef<boolean>(false);
  const hideOrderProgressCard = useRef<boolean>(false);
  const showCompanyStockOMS = useRef<boolean>(false);
  const [deliveryDatePrimary, setDeliveryDatePrimary] = useState<string>("");
  const [addMoreLoading, setAddMoreLoading] = useState(false);
  const warehouseId = useRef<string>("");
  const siteWarehouseMappingRef = useRef<any>({});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [scrollTop, setScrollTop] = useState<number>(0); 
  const scrollRef = useRef<HTMLDivElement>(null);
  const [allowTableScroll, setAllowTableScroll] = useState<boolean>(false);
  const [dontAllowContainerScroll, setDontContainerScroll] = useState(true);
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {
    batchIdConfiguration = false
  } = ConfigDictionary;

  const insideManageInvoice = location?.pathname?.includes("viewInvoice");

  // those rows are valid which are not a free product
  const validRows = [...rows]?.filter((row: viewManageOrderRowsData) => !row?.freeItem);

  const onCustomAccordionToggle = (isExpanded: boolean) => {
    setIsScrolling(!isExpanded);
  };

  const handlePromotionModalVisibility = (paramRow: any) => {
    setSelectedSkuCode(paramRow?.batchCode);
    dispatch(setDiscountModalState(true));
  };

  const handleOrderStatusChange = async (id: string) => {
    const isCancellingOrderOrInvoice: boolean = id?.toUpperCase() == "REJECTED" || id?.toUpperCase() == "CANCELLED";

    const cancelInvoicePayload = insideManageInvoice
      ? { invoiceNumber: orderData?.invoiceNumber }
      : {};

    const cancelInvoiceOrOrderPayload = isCancellingOrderOrInvoice
      ? { statusReason: selectedRejectionReason }
      : {};

    let requestBody = {
      status: id,
      ...cancelInvoicePayload,
      ...cancelInvoiceOrOrderPayload,
    };

    setOrderStatusChangeLoading(id);

    try {
      if (insideManageInvoice) {
        await updateInvoiceStatus(requestBody);
        navigate("/dashboard/sale/manageInvoices");
      } else {
        await updateOrderStatus(requestBody, orderData?.orderNumber);
        await getOrderDetails(
          orderId ? orderId : insideManageInvoice ? orderData?.orderNumber : orderData?.id
        );
      }

      resetGenericModalProps();
    } catch (e) {
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `Error while updating ${insideManageInvoice ? `invoice` : `order`} status`
        )
      );
    } finally {
      setOrderStatusChangeLoading("");
      setIsEditing(false);
      if (isCancellingOrderOrInvoice) resetRejectOrderState();
    }
  };
  const handleSiteIdChange = (siteId: string) => {
    setOrderData((prev: any) => ({
      ...prev,
      siteId, 
      extendedAttributes: {
        ...prev.extendedAttributes,
        siteId, 
      },
    }));
  console.log("Updated siteId:", siteId);
};

const handleWarehouseIdChange = async (warehouseId: string) => {
  setOrderData((prev: any) => ({
    ...prev,
    warehouseId, 
    extendedAttributes: {
      ...prev.extendedAttributes,
      warehouseId, 
    },
  }));
    console.log("Updated warehouseId:", warehouseId);
}

  const resetRejectOrderState = () => {
    setOrderCancelModalOpen(false);
    setSelectedRejectionReason("");
  };

  const handleCreateInvoice = async (invoiceNumber: string = "", viewInvoice: boolean = false) => {
    try {
      setOrderStatusChangeLoading(viewInvoice ? "VIEW_INVOICE" : "INVOICE");

      // when we are opening an order with status "INVOICED"
      if (invoiceNumber) {
        const blobKey = await createAndDownloadInvoicePdf([invoiceNumber]);
        return blobKey[0];
      }

      // when the order status is confirmed, first we need to handle the applied discount and change its status to "INVOICED"
      const discountPayload = {
        orderNumber: orderData?.orderNumber,
        discountType: discount?.discountType?.toLocaleLowerCase() ?? "value",
        discountValue: parseFloat(discount?.discountValue || "0"),
      };

      // api call to change the order status and send discount data
      const response = await createInvoice(discountPayload);

      if (response?.status === 200) {
        await getOrderDetails(orderId ?? orderData?.id ?? "");
      } else {
        setGenericModalProps(getGenericModalProps("error", "Error while pushing order to GRN"));
      }
    } catch (error) {
      console.error(error);
      setGenericModalProps(
        getGenericModalProps("error", "Error while pushing order to GRN")
      );
    } finally {
      setModalOpen(false);
      setOrderStatusChangeLoading("");
    }
  };


  const handleOnBlur = (paramRow: any) => {
    if (ConfigDictionary?.uomConversionPrimary) {
      const {
        batchCode,
        caseQuantity,
        otherUnitQuantity,
        pieceQuantity,
        casePrice,
        otherUnitPrice,
        price,
        availableStock,
        caseToPieceQty,
        otherToPieceQty,
        otherUnitName,
        uom,
      } = paramRow ?? {};
      const { convertedCaseQty, convertedOtherQty, convertedPieceQty } = performUomConversionPrimary(
        caseQuantity,
        otherUnitQuantity,
        pieceQuantity,
        uom,
        caseToPieceQty,
        otherToPieceQty,
        availableStock?.cs,
        availableStock?.other,
        availableStock?.pc,
        true,
      );

      updateMultiQtyInCart(
        batchCode,
        {
          caseQuantity: convertedCaseQty,
          otherUnitQuantity: convertedOtherQty,
          pieceQuantity: convertedPieceQty,
        },
        { outletCode: orderData?.outletCode },
        catalogue,
        setCart
      );

      setRows((prevRows) =>
        prevRows?.map((row) =>
          row?.batchCode === paramRow?.batchCode
            ? {
                ...row,
                caseQuantity: convertedCaseQty,
                otherUnitQuantity: convertedOtherQty,
                pieceQuantity: convertedPieceQty,
                actualAmount: `${
                  +row?.actualAmount -
                  (caseQuantity * casePrice +
                    otherUnitQuantity * otherUnitPrice +
                    pieceQuantity * price) +
                  (convertedCaseQty * casePrice +
                    convertedOtherQty * otherUnitPrice +
                    convertedPieceQty * price)
                }`,
              }
            : row
        )
      );
    }
  };


  const handleQuantityChange = (paramRow: any, changedQuantity: number, type: UOM) => {
    if (changedQuantity >= 0) {
      const quantityKey =
        type === UOM.CASE
          ? "caseQuantity"
          : type === UOM.OTHER
            ? "otherUnitQuantity"
            : "pieceQuantity";
      const priceKey =
        type === UOM.CASE ? "casePrice" : type === UOM.OTHER ? "otherUnitPrice" : "price";
        updateQuantityInCart(
          paramRow?.batchCode,
          changedQuantity,
          type,
          { outletCode: orderData?.outletCode },
          catalogue,
          setCart
        );
      
      setRows((prevRows) =>
        prevRows?.map((row) =>
          row?.batchCode === paramRow?.batchCode
            ? {
              ...row,
              [quantityKey]: changedQuantity,
              actualAmount: `${Number(row?.actualAmount) -
                paramRow[quantityKey] * paramRow[priceKey] +
                changedQuantity * paramRow[priceKey]
                }`,
            }
            : row
        )
      );
    }
  };

  const handleRemove = (paramRow: any) => {
    updateMultiQtyInCart(
      paramRow?.batchCode,
      {
        caseQuantity: 0,
        otherUnitQuantity: 0,
        pieceQuantity: 0,
      },
      { outletCode: orderData?.outletCode },
      catalogue,
      setCart
    )
    setRows((prevRows) => prevRows?.filter((row) => row?.batchCode !== paramRow?.batchCode));
  };

  const handleReset = async () => {
    setSearchedValue("");
    await setDataRowAndFooter(orderData);
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const populateCartDuringEditOrder = async (data: any, addMore: boolean = false) => {
    try {

      let orderedBatchCodes: string | string[] =
        getBatchCodes(
          data?.orderDetails
            ?.map((item: any) => item?.type !== "freeItem" ? item : null)
            ?.filter(Boolean)
        ) ?? "";

      orderedBatchCodes = orderedBatchCodes?.split(",") ?? []
      const pricingData = await createCatalogue(OrderType.PRIMARY, data?.outletCode, !disableSchemeCheck.current, orderedBatchCodes);

      if (pricingData && Array.isArray(pricingData) && pricingData?.length == 0) {
        setGenericModalProps(
          getGenericModalProps("error", "Some items in this order could not be edited due to missing/incorrect pricing data. Please update the data in the MDM & Integration Page.")
        );
        return "invalidPricing"
      }

      const catalogueData = await getDataFromLocalDb("PrimaryCatalogue");
      setCatalogue(catalogueData?.data);
      data?.orderDetails
        ?.filter((sku: any) => sku?.type !== "freeItem")
        ?.forEach((order: any) => {
          const {
            batchCode,
            caseQuantity,
            pieceQuantity,
            otherUnitQuantity,
            initialNormalizedQuantity,
          } = order;
          if (initialNormalizedQuantity > 0) {
            updateMultiQtyInCart(
              batchCode,
              {
                caseQuantity: caseQuantity,
                otherUnitQuantity: otherUnitQuantity,
                pieceQuantity: pieceQuantity,
              },
              { outletCode: addMore ? 'self' : orderData?.outletCode },
              catalogueData?.data,
              setCart
            );
          }
        });
    } catch (err: any) {
      console.error(err);
      if (err?.message === "pricing") {
        setGenericModalProps(
          getGenericModalProps("error", "⚠️  Unable to fetch pricing details. Please try again later.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps)
              setIsEditing(false);
            }
          ));
      } else if (err?.message === "offers") {
        setGenericModalProps(
          getGenericModalProps("error", "⚠️  Unable to load offer details. Please refresh or try again.",
            "Ok",
            ``,
            () => {
              setGenericModalProps(initialGenericModalProps)
              setIsEditing(false);
            }
          )
        );
      } else {
        setGenericModalProps(
          getGenericModalProps("error", `Order with Id ${orderId} not found`)
        );
      }
    }
  };

  const createStockData = async (batchCodes: string = "") => {
    try {
      setOrderStatusChangeLoading("STOCKS");
      const data = await setRealTimeStockDataInDb(batchCodes, "caseQty", "", warehouseId.current);
      return createSkuWiseStockMap(data);
    } catch (e) {
      console.error(e);
      setGenericModalProps(getGenericModalProps("error", "⚠️  Unable to fetch stocks data"));
    } finally {
      setOrderStatusChangeLoading("");
    }
  };

  const setDataRowAndFooter = async (
    data: any,
    tableRows: viewManageOrderRowsData[] = [],
    tableHeaders?: Record<string, string>
  ) => {
    try {
      let stocksData: any = {};
      warehouseId.current = data?.extendedAttributes?.siteId ?? "";

      if (showCompanyStockOMS.current){
        const orderedBatchCodes: string = getBatchCodes(data?.orderDetails) ?? "";
        stocksData = await createStockData(orderedBatchCodes);
      }
      
      const dbResult = await getDataFromLocalDb("Product");
      const products: any = dbResult?.data?.[0]?.data ?? {};

      // special case when we need to populate the rows with updated data
      if (tableRows?.length) {
        const updatedRows = tableRows?.map((row: viewManageOrderRowsData) => {
          const skuStock = stocksData?.[row?.batchCode];
          const {
            availableCaseQty,
            availablePieceQty,
            availableOtherQty,
            committedCaseQty,
            committedPieceQty,
            committedOtherQty,
          } = skuStock || {};
          const availableStock = {
            cs: availableCaseQty || 0,
            pc: availablePieceQty || 0,
            other: availableOtherQty || 0,
            csComitted: committedCaseQty || 0,
            pcComitted: committedPieceQty || 0,
            otherComitted: committedOtherQty || 0,
          };
          return { ...row, availableStock };
        });
        setRows(updatedRows || []);
        return;
      }

      const totalData = getOrderTotalRowData(data, tableHeaders ?? TableHeaders, ConfigDictionary);
      setTotalFooterValue(totalData);

      let dataArr: viewManageOrderRowsData[] = [];
      let taxAmount: number = 0;

      const orderUomCheckConfig = await getConfigData("catalogue_configuration", "orderUomCheck");
      const orderUomCheck = orderUomCheckConfig[0]?.configValue ?? "";

      data?.orderDetails?.forEach((item: any, index: any) => {
        const {
          source,
          batchCode,
          price,
          casePrice,
          otherUnitPrice,
          pieceQuantity,
          caseQuantity,
          otherUnitQuantity,
          productInfo,
          creationTime,
          netAmount,
          initialAmount,
          extendedAttributes,
          type,
          discountValue,
          initialNormalizedQuantity,
          couponValue,
          normalizedQuantity
        } = item;
        const discount = truncateToTwoDecimals((discountValue ?? 0) + (couponValue ?? 0));
        const finalAmount = netAmount ? truncateToTwoDecimals(netAmount) : "0";
        const actualAmount = initialAmount ? truncateToTwoDecimals(initialAmount) : "0";
        const skuDescription = productInfo?.skuDescription ?? "-";
        const formattedPrice = truncateToTwoDecimals(price ?? 0);
        const formattedCasePrice = truncateToTwoDecimals(casePrice ?? 0);
        const formattedOtherPrice = truncateToTwoDecimals(otherUnitPrice ?? 0);
        const id = `row-${index + 1}`;

        const freeItem: boolean = type === "freeItem" || (!insideManageInvoice && item?.initialNormalizedQuantity === 0)

        const taxInfo = extendedAttributes?.taxInfo;
        if (!freeItem) {
          taxInfo?.forEach((taxType: any) => (taxAmount += taxType?.taxAmount || 0));
        }

        const skuDiscountInfo = [
          { discountType: "Coupon", discountAmount: couponValue ?? 0 },
          { discountType: "Scheme", discountAmount: discountValue ?? 0 },
        ]

        // setting available stock of the product
        const skuStock = stocksData?.[batchCode];

        const {
          availableCaseQty,
          availablePieceQty,
          availableOtherQty,
          committedCaseQty,
          committedPieceQty,
          committedOtherQty,
        } = skuStock || {};
        const availableStock = {
          cs: availableCaseQty || 0,
          pc: availablePieceQty || 0,
          other: availableOtherQty || 0,
          csComitted: committedCaseQty || 0,
          pcComitted: committedPieceQty || 0,
          otherComitted: committedOtherQty || 0,
        };

        const status = data?.status?.toLocaleUpperCase();

        const caseToPieceQuantity = productInfo?.caseToPieceQuantity ?? 0;
        const otherUnitToPieceQuantity = productInfo?.otherUnitToPieceQuantity ?? 0;

        const totalConvertedCasesPrimaryOMS = Math.trunc(
          caseQuantity +
          (otherUnitToPieceQuantity === 0 ? 0 :
            otherUnitQuantity * (otherUnitToPieceQuantity / caseToPieceQuantity)) +
          (caseToPieceQuantity === 0 ? 0 :
            pieceQuantity / caseToPieceQuantity)
        );

        dataArr.push({
          id,
          source,
          batchCode,
          skuDescription,
          caseQuantity,
          pieceQuantity,
          otherUnitQuantity,
          casePrice: formattedCasePrice,
          price: formattedPrice,
          otherUnitPrice: formattedOtherPrice,
          actualAmount,
          discount,
          finalAmount,
          creationTime,
          availableStock,
          taxInfo,
          status,
          uom: orderUomCheck === "true" ? (products[batchCode]?.uom ?? "") : "all",
          initialCaseQuantity: caseQuantity,
          initialOtherUnitQuantity: otherUnitQuantity,
          initialPieceQuantity: pieceQuantity,
          freeItem,
          caseToPieceQty: products[batchCode]?.caseToPieceQuantity ?? extendedAttributes?.["caseToPiece"] ?? 99999,
          otherToPieceQty: products[batchCode]?.otherUnitToPieceQuantity ?? 99999,
          initialNormalizedQuantity,
          skuDiscountInfo,
          actualCaseQuantity: caseQuantity,
          actualPieceQuantity: pieceQuantity,
          actualOtherUnitQuantity: otherUnitQuantity,
          totalConvertedCasesPrimaryOMS,
        });
      });

      setOrderData({ ...data, taxAmount });

      setRows(dataArr);
    } catch (e) {
      console.error(e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching available stock data")
      );
    }
  };

  const getOrderDetails = async (orderId: string, TableHeaders?: Record<string, string>) => {
    try {
      let res, data;

        try {
          res = await getSinglePrimaryOrder(orderId);
          data = res?.data?.features?.[0];

          // Calculate deliveryDatePrimary
          const orderFulfillmentConfigPrimary = ConfigDictionary?.orderFulfillmentTimePrimary
            ? ConfigDictionary?.orderFulfillmentTimePrimary
            : 2;
          setDeliveryDatePrimary(
            dayjs(data?.creationTime)
              .add(orderFulfillmentConfigPrimary, "day")
              .format("YYYY-MM-DD HH:mm:ss")
          );

        } catch (e) {
          console.error(e);
          throw new Error();
        }

      await setDataRowAndFooter(data ?? {}, [], TableHeaders);
    } catch (err) {
      console.error(err);
      setGenericModalProps(
        getGenericModalProps(
          "error",
          `${insideManageInvoice ? `Invoice` : `Order`} with order-number : ${orderId} not found`
        )
      );
    } finally {
      setLoader(false);
    }
  };

  const fetchRequiredConfigs = async () => {
    try {
      const stages = ConfigDictionary?.primaryOrderTrackingStages;
      stages.unshift({
        id: "ALLORDERS",
        color: "#F0F3FF",
        label: "All Orders",
        labelColor: "",
      });
      const rejectionReasonsConfig = await getConfigData(
        "dms_configuration",
        "orderCancellationReasons"
      );

      const res = await getConfigData("dms_configuration", "hideAddMoreInEditOrder");
      const res7 = await getConfigData("dms_configuration", "disableSchemeCheck");
      const res4 = await getConfigData("dms_configuration", "hideItemLevelTaxInfo");
      const res5 = await getConfigData("dms_configuration", "hideOrderProgressCard");
      const kgbplDeliveryMetadataConfig = await getConfigData("dms_configuration", "showKGBPLOrderSummary");
      kgbplDeliveryMetadata.current = kgbplDeliveryMetadataConfig[0]?.configValue ??false;

      const res6 = await getConfigData("order_configuration", "goToInvoiceRedirectionButton");

      const res8 = await getConfigData("dms_configuration", "showPushToGrnButton");
      const res9 = await getConfigData("dms_configuration", "showCancelOrderButton");
      const res10 = await getConfigData("dms_configuration", "showCompanyStockOMS");
      setPushToGrnButton(res8[0]?.configValue ?? false)
      setCancelOrderButton(res9[0]?.configValue ?? false)

      disableSchemeCheck.current = res7[0]?.configValue ?? false;
      hideAddMoreInEditOrder.current = res[0]?.configValue ?? false;
      disableEditInvoiceFlow.current = true;
      disableStockCheck.current = true;
      hideItemLevelTaxInfo.current = res4[0]?.configValue ?? false;
      hideOrderProgressCard.current = res5[0]?.configValue ?? false;
      showGoToInvoiceRedirectionButton.current = res6[0]?.configValue ?? false;
      showCompanyStockOMS.current = res10[0]?.configValue ?? false;

      setRejectionReasons(rejectionReasonsConfig?.[0]?.configValue ?? []);
      setOrderTrackingConfig(stages ?? []);

      if(ConfigDictionary?.showSiteWarehouseFilterViewPrimaryOMS) {
        const dbResult = await getDataFromLocalDb("SiteWarehouseIdMapping");
        siteWarehouseMappingRef.current = dbResult?.data?.[0]?.data ?? {};
      }

    } catch (e) {
      console.error("Error while fetching configs", e);
    }
  };

  useEffect(() => {
    const tableData = setAndGetViewOrderEditTableHeader(ConfigDictionary, true);
    SetViewOrderEditTableHeader(tableData);

    if (orderId) {
      setLoader(true);

      // Chain the promises to ensure fetchRequiredConfigs runs first
      fetchRequiredConfigs()
        .then(() => getOrderDetails(orderId, tableData))
        .finally(() => {
          setLoader(false);
        });
    } else {
      navigate("/dashboard/sale/manageOrders", { replace: true });
      return;
    }
  }, [orderId, insideManageInvoice]);

  const handleSaveQuantityChanges = async (id: boolean = false) => {
    if(saveChangesLoading) return
    setSaveChangesLoading(true);

    if(ConfigDictionary?.showSiteWarehouseFilterViewPrimaryOMS && id) {
    const res = await populateCartDuringEditOrder(orderData);
      if (res === "invalidPricing") {
        setGenericModalProps(getGenericModalProps("error", `Error while saving the changes`));
        return;
    }
    }
    const validOrderData = JSON.parse(JSON.stringify(orderData));
    const validOrderDetails = validOrderData?.orderDetails?.filter(
      (sku: any) => sku?.type !== `freeItem`
    );
    validOrderData.orderDetails = validOrderDetails;

        console.log(cart);
        console.error("Testing 03")
    const modifiedCart: any = await modifyCartToValidate(setCart, validOrderData);
        console.log(cart);
        console.error("Testing 04")

    let editedSkus: string[] = [];
    let editedCQ: number = 0;
    let editedPQ: number = 0;
    let editedOUQ: number = 0;

    for (const row of rows) {
      if (
        (row?.actualCaseQuantity !== row?.caseQuantity) ||
        (row?.actualPieceQuantity !== row?.pieceQuantity) ||
        (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity)
      ) {
        // Accumulate the edited quantities if changes are detected
        if (row?.actualCaseQuantity !== row?.caseQuantity) {
          editedCQ += row?.actualCaseQuantity - row?.caseQuantity;
        }

        if (row?.actualPieceQuantity !== row?.pieceQuantity) {
          editedPQ += row?.actualPieceQuantity - row?.pieceQuantity;
        }

        if (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity) {
          editedOUQ += row?.actualOtherUnitQuantity - row?.otherUnitQuantity;
        }

        if ((editedCQ !== 0) || (editedPQ !== 0) || (editedOUQ !== 0)) {
          editedSkus.push(row?.batchCode);
        }
      }
    }

    try {
      setOrderStatusChangeLoading(id ? "CONFIRMED" : "SAVE_CHANGES");
      if(ConfigDictionary?.showSiteWarehouseFilterViewPrimaryOMS && id) {
        validOrderData.status ="CONFIRMED"
      }
      const requestBody: Record<any, any> | null = getValidateRequestBody(
        modifiedCart?.[validOrderData?.outletCode],
        validOrderData,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        id
      );

        const response = await ChannelkartNetworkPost(
          "/orders/validate?transformerOut=orderDetailSplit",
          requestBody
        );
        if (response?.status === 200 || response?.status === 201) {
          const validateResponse = response?.data?.feature?.[0];
          delete validateResponse["creationTime"];
          const orderPutPayload = prepareEditOrderReqBody(validateResponse, validRows);
          await updateOrder(orderPutPayload, validOrderData?.orderNumber);

        if (id) {
          await handleOrderStatusChange("CONFIRMED");
        }
          let prevBatchCodes: string[] = orderData?.orderDetails?.map((s: any) => s?.batchCode).collect ?? [];
          let newBatchCodes: string[] = validateResponse?.orderDetails?.map((s: any) => s?.batchCode).collect ?? [];
          let uniqueNewBatchCodes = newBatchCodes?.filter(code => !prevBatchCodes?.includes(code)).join(",");
          let uniqueNewBatchCodesNormalizedQuantity = validateResponse?.orderDetails
            ?.filter((s: any) => uniqueNewBatchCodes?.includes(s?.batchCode))
            ?.reduce((sum: number, s: any) => sum + (s?.normalizedQuantity || 0), 0);
        }

      resetGenericModalProps();
      refresh();
    } catch (e) {
      console.error(e);
      setGenericModalProps(getGenericModalProps("error", `Error while saving the changes`));
    } finally {
      setSaveChangesLoading(false);
      setOrderStatusChangeLoading("");
    }
  };

  const refresh = () => {
    setIsEditing(false);
    setLoader(true);
    Promise.allSettled([
      getOrderDetails(insideManageInvoice ? orderData?.orderNumber : orderData?.id),
    ]).finally(() => {
      setLoader(false);
    });
  };

  const openInvalidOrderModal = () => {
    if (!orderData?.orderNumber && !orderData?.id) {
      setGenericModalProps(getGenericModalProps("error", `Invalid order, cannot proceed`));
      return true;
    } else {
      return false;
    }
  };

  const hasRealChanges = () => {
    // Check if any real changes have been made to the order
    const validOrderData = JSON.parse(JSON.stringify(orderData));
    const validOrderDetails: any = validOrderData?.orderDetails?.filter(
      (sku: any) => sku?.type !== `freeItem`
    ); 
    if (batchIdConfiguration && insideManageInvoice){
      const uniqueValidOrderDetails = Array.from(
        new Set(validOrderDetails.map((item: any) => item?.batchCode))
      );

      if(uniqueValidOrderDetails.length !== rows.length) return true;
    } else {
      if ( validOrderDetails.length !== rows.length ) return true;
    }
   
    
    for (const row of rows) {
      if (
        (row?.actualCaseQuantity !== row?.caseQuantity) ||
        (row?.actualPieceQuantity !== row?.pieceQuantity) ||
        (row?.actualOtherUnitQuantity !== row?.otherUnitQuantity)
      ) {
        return true;
      }
    }
    return false;
  };
  const handleClickAddMore = async () => {
    if (openInvalidOrderModal()) return;
    setAddMoreLoading(true);
    const res = await populateCartDuringEditOrder(orderData, true);
                      if (res === "invalidPricing") {
                        return;
                      }
       setAddMoreLoading(false);

    if (openInvalidOrderModal()) return;

    if(isEditing) {
      sessionStorage.setItem("addMorePressedWhileEditing", "true");
    }
    // Check if we're in editing mode and there are real changes
    if (isEditing && hasRealChanges()) {
      // Check what the leftBtnText would be in the save changes modal
      const wouldShowYes = (checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current));
      
      if (wouldShowYes) {
        // If "Yes" would be shown, directly execute the save changes function
        console.error("Testing 0")
        console.log(cart);
        await handleSaveQuantityChanges();
        console.error("Testing 1")
        console.log(cart);
        console.error("Testing 2")
        
        // Then navigate as usual
        navigate(
          `/dashboard/primaryOms/manageOrders/addMore/${
            insideManageInvoice ? orderData?.orderNumber : orderData?.id
          }?outletId=${orderData?.outletCode}${insideManageInvoice ? `&invoice=true` : ``}`,
          { state: { isPrimaryOMS: true }});
      } else {
        // If "Edit Order" would be shown, show the modal
        await handleClickSaveChanges();
      }
      return;
    }
       setTimeout(() => {
        navigate(
          `/dashboard/primaryOms/manageOrders/addMore/${insideManageInvoice ? orderData?.orderNumber : orderData?.id
          }?outletId=${orderData?.outletCode}${insideManageInvoice ? `&invoice=true` : ``}`
        , { state: { isPrimaryOMS: true }});
       }, 0)
   
  };

  const handleDisableEditing = () => {
    handleReset();
    resetGenericModalProps();
    setIsEditing(false);
  };

  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);

  const handleClickSaveChanges = async () => {
    if (openInvalidOrderModal()) return;

    setSaveChangesLoading(true);
    const isEmptyTable = checkForEmptyTable(validRows);
    if (!isEmptyTable) await setDataRowAndFooter(orderData, rows);
    setSaveChangesLoading(false);

    const message = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)
      ? `Do you wish to save the changes made? ${isEmptyTable ? "Disclaimer: your order will be rejected." : ""
      }`
      : `Ordered quantity is more than the Available stock. Please adjust the quantity before saving.`;

    const leftBtnFn =
      !validRows?.length || isEmptyTable
        ? () => handleOrderStatusChange(insideManageInvoice ? "CANCELLED" : "REJECTED")
        : checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)
          ? () => handleSaveQuantityChanges()
          : () => resetGenericModalProps();

    const rightBtnFn = async () => {
      checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? resetGenericModalProps() : handleDisableEditing();
    };

    const leftBtnText = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? "Yes" : "Edit Order";
    const rightBtnText = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? "No" : "Close";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      leftBtnFn,
      rightBtnFn,
      undefined,
      undefined,
      undefined,
      undefined,
      '455px'
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const handleClickAccept = async () => {
    if (openInvalidOrderModal()) return;

    await setDataRowAndFooter(orderData, rows);

    const message = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)
      ? `Are you sure you want to confirm the order?`
      : `Ordered quantity is more than the available stock. Please edit the order to proceed.`;

    const fn = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current)
      ? () => handleOrderStatusChange("CONFIRMED")
      : () => {
        setIsEditing(true);
        resetGenericModalProps();
      };

    const leftBtnText = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? "Yes" : "Edit";
    const rightBtnText = checkAllRowsHaveValidStock(validRows, isEditing, disableStockCheck.current) ? "No" : "";

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      leftBtnText,
      rightBtnText,
      fn,
      resetGenericModalProps
    );
    setGenericModalProps(updatedGenericModalProps);
  };

  const handleCancel = async () => {
    setEditLoading(true);
    await handleReset();
    setIsEditing(false);
    setEditLoading(false);
  };


  const handleReasonChange = (reason: string) => {
    setSelectedRejectionReason(reason);
  };

  const viewOrderConfig = isEditing
    ? getEditOrderConfig(
      handleQuantityChange,
      handleOnBlur,
      handleRemove,
      handlePromotionModalVisibility,
      insideManageInvoice,
      TableHeaders,
      disableStockCheck.current,
      true,
      false,
      showCompanyStockOMS.current,
    )
    : getViewOrderConfig(
      handlePromotionModalVisibility,
      insideManageInvoice,
      TableHeaders,
      disableStockCheck.current,
      hideItemLevelTaxInfo.current,
      true,
      false,
    );

  const columns: any[] = viewOrderConfig?.columns;


  const showOverlay: boolean =
    showOverlayIn?.includes(orderStatusChangeLoading) || editLoading || saveChangesLoading;

  useEffect(() => {
    if (orderData?.status === "PENDING" && (!isProcessing || !isEditing)) {
      setIsProcessing(true);
    }

    let filtered = filterData([...rows], searchedValue?.toLowerCase(), searchWithStatusFilter)
      ?.filter((row) => (isEditing ? !row?.freeItem : true)) || [];

    setFilteredRows(filtered);
  }, [rows, searchedValue, searchWithStatusFilter, isEditing, orderData]);

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const getOrderCancellationStatusId = () => {
    return orderTrackingConfig?.some((status: any) => status?.id?.toUpperCase() === "CANCELLED") ? "Cancelled" : "REJECTED";
  }

  const getTotalQuantities = (orderData: any, config: any): string[] => {
    const { packUnitLabelPrimary, caseUnitLabelPrimary, otherUnitLabelPrimary } = config;

    return [
      caseUnitLabelPrimary ? `${orderData?.totalCaseQuantity} ${caseUnitLabelPrimary}` : "",
      otherUnitLabelPrimary ? ` ${orderData?.totalOtherUnitQuantity} ${otherUnitLabelPrimary}` : "",
      packUnitLabelPrimary ? ` ${orderData?.totalPieceQuantity} ${packUnitLabelPrimary}` : ""
    ].filter(Boolean); // Removes empty values
  };


  const [isDownloading, setIsDownloading] = useState<boolean>(false); // New state to track full download process
  const [grnSheetLoader, setGrnSheetLoader] = useState<boolean>(false);


  const downloadGrnSheet = async () => {
    if (isDownloading) return; 
    try{
      setIsDownloading(true);
      setGrnSheetLoader(true);
       const reportIdConfig = await getConfigData(
          "dms_configuration",
          "grnSheetReportId"
        );

      const reportId = reportIdConfig[0]?.configValue ?? "";

    await downloadGrnReport(
      reportId,
      "invoiceNumber",
      String(orderData?.invoiceNumber),
      setSnackbarOpen,
      setIsDownloading
    )
    }catch(e){
      console.log(e)
    }finally {
      setGrnSheetLoader(false);
      setIsDownloading(false);
    }
  }
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handler = createScrollHandler(
      scrollRef,
      isScrolling,
      setAllowTableScroll,
      setDontContainerScroll
    );

    el.addEventListener("wheel", handler);

    return () => {
      el.removeEventListener("wheel", handler);
    };
  }, [isScrolling, dontAllowContainerScroll]);

  if (loader) {
    return <Loader />;
  }

  return (
    <>
      <div
        className="view_order_parent_vo"
        onWheel={(e) => handleScroll(e, setIsScrolling, scrollTop)}
      >
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          leftButtonPadding={genericModalProps?.leftButtonPadding}
          onClose={resetGenericModalProps}
          loading={Boolean(orderStatusChangeLoading?.length)}
          width={genericModalProps?.width}
        />
       
        <ScreenOverlay apply={showOverlay} />
        <div className="view_order_header_with_search">
          <div className="view_order_header">
            <FormHeader
              parentLabel={
                insideManageInvoice ? "Manage Invoices" : "Manage Orders"
              }
              label={insideManageInvoice ? "Invoice Details" : "Order Details"}
              goBackToParent={() =>
                navigate(
                  `/dashboard/primaryOms/${
                    insideManageInvoice ? `manageInvoices` : `manageOrders`
                  }`
                )
              }
            />
          </div>
          <div className="view_order_manage_order_search_bar">
            <Search searchFunction={handleSearchValueChange} />
          </div>
        </div>

      <div ref={scrollRef} style={{
          gap: "14px",
          overflow: (dontAllowContainerScroll) ? "hidden" : "scroll",
          height: "100%",
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE 10+
        }}
        >
        <CustomAccordian
          metaData2ChunkSize={(kgbplDeliveryMetadata.current) ? 4 : 3}
          metaData1ChunkSize={(kgbplDeliveryMetadata.current)? 4 : 3}
          expanded={!isScrolling}
          onCustomAccordionToggle={onCustomAccordionToggle}
          isSecondHalf={true}
          metaData1={getMetaData1ViewPrimaryOMS(
            ConfigDictionary?.currency ? ConfigDictionary?.currency : "",
            kgbplDeliveryMetadata.current
          )}
          data1={{
            totalCasePieceOtherQuantity: getTotalQuantities(
              orderData,
              ConfigDictionary
            ),
            totalQuantity: orderData?.lineCount,
            netAmount: orderData?.totalAmount,
            discountValue: orderData?.totalDiscountValue,
            taxAmount: orderData?.taxAmount ?? 0,
            billAmount: orderData?.netAmount,
            totalConvertedCasesPrimaryOMS : (rows.reduce((sum, item) => sum + (item.totalConvertedCasesPrimaryOMS || 0), 0)),
              totalWeight: orderData?.totalWeight ?? 0,
          }}
          metaData2={metaData2ViewPrimaryOMS(kgbplDeliveryMetadata.current,(orderData?.siteId === null || orderData?.siteId === "null") ? "" : orderData?.siteId ?? "", siteWarehouseMappingRef.current,orderData?.status)}
          data2={{
            supplierCode: orderData?.supplier,
            supplierName: orderData?.supplierName,
            deliveryDate: deliveryDatePrimary,
              siteId: (orderData?.siteId === null || orderData?.siteId === "null" )? "" : orderData?.siteId ?? "",
              warehouseId:( orderData?.warehouseId === null || orderData?.warehouseId === "null") ? "" : orderData?.warehouseId ?? "",
              outletCity : orderData?.outletCity ?? "",
              outletName :  orderData?.outletName ?? "",
              outletCode: orderData?.outletCode ?? ""
          }}
          header={`Order No. ${orderData?.orderNumber}`}
          label1="Order Summary"
          label2= {(kgbplDeliveryMetadata.current) ? "Order Details" :"Delivery Details"}
          dateAndTimeLabel="Order time & date"
          dateAndTimeValue={orderData?.creationTime}
          statusConfig={orderTrackingConfig}
          status={orderData?.status}
          onSiteIdChange={handleSiteIdChange} 
          onWarehouseIdChange={handleWarehouseIdChange}
          siteWarehouseMapping={siteWarehouseMappingRef.current}
        />

        <div style={{height: "100%", position: "sticky", top: "0"}}>
            <div className="view_order_details_vo">
          <div className="view_order_button_container">
            <BorderHeading>
              {insideManageInvoice ? "Invoice Details" : "Order Details"}
            </BorderHeading>
            {
            orderData?.status?.toUpperCase() === "CONFIRMED" ||
            orderData?.status?.toUpperCase() === "REJECTED" ||
            orderData?.status?.toUpperCase() === "CANCELLED" ||
            orderData?.status?.toUpperCase() === "DELIVERED" ||
            orderData?.status?.toUpperCase() === "PARTIAL DELIVERED" ||
            orderData?.status?.toUpperCase() === "OUT FOR DELIVERY" ||
            (orderData?.status?.toUpperCase() === "INVOICED" &&
              !insideManageInvoice) ? (
              <></>
            ) : (
              <div style={{ display: "flex", gap: "8px" }}>
                {isEditing ? (
                  <Button
                    className="view_order_reset_button"
                    onClick={async () => {
                      if (editLoading) return;
                      setEditLoading(true);
                      await handleReset();
                      setEditLoading(false);
                    }}
                  >
                    <div className="view_order_icon_wrapper">
                      <RenderSvg name={"backIcon"} />
                    </div>{" "}
                    Reset changes
                  </Button>
                ) : (
                  <></>
                )}
                
                {!orderData?.eInvoiced && !invoiceExpired && !isEditing && (
                  <Button
                    className="view_order_reset_button"
                    disabled={isEditing}
                    onClick={async () => {
                      if (editLoading) return;
                      if (openInvalidOrderModal()) return;
                      setEditLoading(true);
                      await setDataRowAndFooter(orderData, rows);
                      const res = await populateCartDuringEditOrder(orderData);
                      if (res === "invalidPricing") {
                        setEditLoading(false);
                        return;
                      }
                      // setSnackbarOpen(true);
                      setEditLoading(false);
                      setIsEditing(true);
                    }}
                    sx={{
                      gap: "2px",
                      minHeight: "34px",
                      minWidth: "71px",
                      cursor: "pointer",
                      borderColor: isEditing ? "#00000042 !important" : "",
                    }}
                  >
                    <div className="view_order_icon_wrapper">
                      <RenderSvg name={"viewAndEditIcon"} />
                    </div>
                    Edit
                  </Button>
                )}

                { !orderData?.eInvoiced &&
                  !hideAddMoreInEditOrder.current &&
                  !invoiceExpired && (
                    <Button
                      className="view_order_add_more_button"
                      variant="contained"
                      color="primary"
                      onClick={addMoreLoading ? () => {} : handleClickAddMore}
                    >
                      <ShoppingCartIcon className="view_order_cart_icon" />
                      Add more
                      {addMoreLoading ? (
                        <>
                          &nbsp;
                          <CircularProgress
                            style={{ ...customStyle, height: 16, width: 16 }}
                          />
                        </>
                      ) : null}
                    </Button>
                  )}
              </div>
            )}
          </div>
        
        {isEditing && (
          <p className="ViewOrder_schemeDisclaimer" style={{marginTop: "-5px", marginBottom: "5px"}}>
            *Benefit of promotion applied will change as per the updated
            quantity of the SKU
          </p>
        )}
        {loader || editLoading ? (
          <Loader />
        ) : (
          <CustomTablewithTotalInfo
            data={filteredRows}
            columns={columns}
            totals={[]}
            headerBackgroundColor="#F0FBFF"
            isEditing={isEditing}
            children={
              insideManageInvoice &&
              orderData?.status?.toUpperCase() === "INVOICED" ? (
                isEditing ? (
                  <PendingButtons
                    isPrimary={true}
                    showPushToGrnButton={false}
                    batchIdConfiguration={batchIdConfiguration}
                    handleCreateInvoice={handleCreateInvoice}
                    isEditing={isEditing}
                    handleClickSaveChanges={handleClickSaveChanges}
                    handleCancel={handleCancel}
                    orderStatusChangeLoading={orderStatusChangeLoading}
                    saveChangesLoading={saveChangesLoading}
                  />
                ) : (
                  <></>

                )
              ) : orderData?.status?.toLowerCase() === "pending" ? (
                <PendingButtons
                  showPushToGrnButton={false}
                  isPrimary={true}
                  handleCreateInvoice={handleCreateInvoice}
                  isEditing={isEditing}
                  handleClickReject={() => setOrderCancelModalOpen(true)}
                  handleClickSaveChanges={handleClickSaveChanges}
                  handleClickAccept={ConfigDictionary?.showSiteWarehouseFilterViewPrimaryOMS ? () => { handleSaveQuantityChanges(true) } : handleClickAccept}
                  handleCancel={handleCancel}
                  orderStatusChangeLoading={orderStatusChangeLoading}
                  batchIdConfiguration={batchIdConfiguration}
                  saveChangesLoading={saveChangesLoading}
                />
              ) : orderData?.status?.toLowerCase() === "confirmed" ||
                orderData?.status?.toLowerCase() === "partially confirmed" ? (
                isEditing ? (
                  <PendingButtons
                    showPushToGrnButton={false}
                    isPrimary={true}
                    batchIdConfiguration={batchIdConfiguration}
                    handleCreateInvoice={handleCreateInvoice}
                    isEditing={isEditing}
                    handleClickSaveChanges={handleClickSaveChanges}
                    handleCancel={handleCancel}
                    orderStatusChangeLoading={orderStatusChangeLoading}
                    saveChangesLoading={saveChangesLoading}
                  />
                ) : (
                  <div className="view_order_action_buttons_wrapper">
                  { showCancelOrderButton && ( 
                    <Button
                      className="view_order_action_button"
                      key={"REJECTED"}
                      sx={{
                        minWidth: "100px",
                        color: `#ffffff !important`,
                        fontWeight: 500,
                        fontSize: `12px !important`,
                        backgroundColor: `#C64C00 !important`,
                        border: `1px solid #C64C00 !important`,
                        cursor: "pointer",
                        letterSpacing: "0.0001rem",
                        paddingLeft: "12px",
                        "&:hover": {
                          backgroundColor: `#C64C00 !important`,
                        },
                        textTransform: "none",
                      }}
                      onClick={() => setOrderCancelModalOpen(true)}
                    >
                      {buttonLoading(orderStatusChangeLoading, "REJECTED") ? (
                        <CircularProgress style={customStyle} />
                      ) : (
                        "Cancel Order"
                      )}
                    </Button>
                  )}
                  { showPushToGrnButton && ( 
                    <Button
                      className="view_order_action_button"
                      sx={{
                        minWidth: "100px",
                        color: `#ffffff !important`,
                        fontWeight: 500,
                        fontSize: `12px !important`,
                        backgroundColor: `#00C6B1 !important`,
                        border: `1px solid #00C6B1 !important`,
                        cursor: "pointer",
                        paddingLeft: "12px",
                        letterSpacing: "0.0001rem",
                        "&:hover": {
                          backgroundColor: `#00C6B1 !important`,
                        },
                        textTransform: "none",
                      }}
                      onClick={() => handleCreateInvoice()}
                    >
                      {buttonLoading(orderStatusChangeLoading, "INVOICE") ? (
                        <CircularProgress style={customStyle} />
                      ) : (
                        "Push to GRN"
                      )}
                    </Button>
                    )}
                  </div>
                )
              ) : (
                <></>
              )
            }
          />
        )}
        </div>
      </div>
      </div>
      </div>
      <NewDiscountModal skuData={orderData} selectedSkuCode={selectedSkuCode} />

      <OrderCancelModal
        headerText={`${
          insideManageInvoice ? `Invoice` : `Order`
        } is being cancelled.`}
        modalOpen={orderCancelModalOpen}
        selectedRejectionReason={selectedRejectionReason}
        loading={
          buttonLoading(orderStatusChangeLoading, "CANCELLED") ||
          buttonLoading(orderStatusChangeLoading, "REJECTED")
        }
        rejectionReasons={rejectionReasons}
        onClose={resetRejectOrderState}
        handleReasonChange={handleReasonChange}
        onButtonClick={() =>
          handleOrderStatusChange(
            insideManageInvoice ? "CANCELLED" : getOrderCancellationStatusId()
          )
        }
      />
    </>
  );
};

export default ViewPrimaryOrderOms;
